import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // Import useNavigate
import { sendCodedLog } from '../../services/logService';
import Common from '../../common/Common';
import { FaCheck, FaShoppingCart, FaTimes } from "react-icons/fa";

// Import for useAuth hook and API_URLS
import { useAuth } from '../../context/AuthContext';

// Placeholder image - Replace with a generic thumbnail suitable for the transmissions
import defaultThumb from '../../assets/images/merkaba/Merkaba.png';
import UrlConfig from '../../data/UrlConfig';

// Data extracted and deduplicated from the provided images
const transmissionsData = [
  { id: 'soul-blueprint', title: "Bashar - Soul Blueprint Workshop" },
  { id: 'shifting-realities', title: "Bashar - Shifting Realities" },
  { id: 'echoes-of-sedona', title: "Bashar - Echoes Of Sedona" },
  { id: 'facing-your-demons', title: "Bashar - Facing Your Demons" },
  { id: 'open-contact-part-two', title: "Bashar - Open Contact Part Two" },
  { id: 'open-contact-part-one', title: "Bashar - Open Contact Part One" },
  { id: 'social-experiment-step-six', title: "Bashar - Social Experiment Step Six" },
  { id: 'social-experiment-step-five', title: "Bashar - Social Experiment Step Five" },
  { id: 'day-of-reflection', title: "Bashar - The Day Of Reflection" },
  { id: 'resonance-of-the-land', title: "Bashar - Resonance Of The Land" },
  { id: 'preparer-of-the-way', title: "Bashar - Preparer Of The Way" },
  { id: 'time-of-change', title: "Bashar - A Time Of Change" },
  { id: 'association-business', title: "Bashar - Association Business" },
  { id: 'etheric-fauna-and-the-dragon', title: "Bashar - Etheric Fauna And The Dragon" },
  { id: 'is-there-a-santa-clause', title: "Bashar - Is There A Santa Clause?" },
  { id: '7-sequential-steps-of-manifestation', title: "Bashar - 7 Sequential Steps Of Manifestation" },
  { id: 'believing-is-seeing', title: "Bashar - Believing Is Seeing" },
  { id: 'healing-the-world-japan', title: "Bashar - Healing The World (Japan)" },
  { id: 'prime-radiant-aka-god-particle', title: "Bashar - Prime Radiant Aka God Particle" },
  { id: 'invisible-and-visible-things-japan', title: "Bashar - Invisible And Visible Things (Japan)" },
  { id: 'redefining-dogma', title: "Bashar - Redefining Dogma" },
  { id: 'future-memory', title: "Bashar - Future Memory" },
  { id: 'the-men-in-black', title: "Bashar - The Men In Black" },
  { id: 'theology-class', title: "Bashar - Theology Class" },
  { id: 'mechanics-of-metaphysics', title: "Bashar - Mechanics Of Metaphysics" },
  { id: 'new-metaphysics', title: "Bashar - New Metaphysics" },
  { id: 'exploration-with-bashar', title: "Bashar - Exploration With Bashar" },
  { id: 'tools-for-success', title: "Bashar - Tools For Success" },
  { id: 'system-of-belief', title: "Bashar - System Of Belief" },
  { id: 'synchronicity', title: "Bashar - Synchronicity" },
  { id: 'accepting-yourself', title: "Bashar - Accepting Yourself" },
  { id: 'earth-history', title: "Bashar - Earth History" },
  { id: 'dream-reality', title: "Bashar - Dream Reality" },
  { id: 'why-are-you-here', title: "Bashar - Why Are You Here In Physical Reality?" },
  { id: 'achieving-perfect-health', title: "Bashar - Achieving Perfect Health" },
  { id: 'you-are-an-eternal-being', title: "Bashar - You Are An Eternal Being" },
  { id: 'metaphysical-misconceptions', title: "Bashar - Metaphysical Misconceptions" },
  { id: 'transforming-core-beliefs', title: "Bashar - Transforming Core Beliefs" },
  { id: 'soul-cycle', title: "Bashar - Soul Cycle" },
  { id: 'waves-of-energy', title: "Bashar - Waves Of Energy" },
  { id: 'vortex-vibrations', title: "Bashar - Vortex Vibrations" },
  { id: 'living-your-excitement', title: "Bashar - Living Your Excitement" },
  { id: 'permission-slips', title: "Bashar - Permission Slips" },
  { id: 'your-et-neighbors', title: "Bashar - Your ET Neighbors" },
  { id: 'ets-and-the-multiverse', title: "Bashar - ETs And The Multiverse" },
  { id: 'the-eye-of-the-beholder', title: "Bashar - The Eye Of The Beholder" },
  { id: 'the-tesseract-workshop', title: "Bashar - The Tesseract Workshop" },
  { id: 'social-experiment-step-three', title: "Bashar - Social Experiment Step Three" },
  { id: 'the-window-of-discovery', title: "Bashar - The Window Of Discovery" },
  { id: 'mistaken-identity', title: "Bashar - Mistaken Identity" },
  { id: 'the-first-level-of-mastery', title: "Bashar - The First Level Of Mastery" },
  { id: 'the-one', title: "Bashar - The One" },
  { id: 'on-our-own', title: "Bashar - On Our Own" },
  { id: 'facets-of-creation', title: "Bashar - Facets Of Creation" },
  { id: 'the-other-side', title: "Bashar - The Other Side" },
  { id: 'the-dolphin-et-workshop', title: "Bashar - The Dolphin ET Workshop" },
  { id: 'an-evening-with-bashar-in-hawaii', title: "Bashar - An Evening With Bashar In Hawaii" },
  { id: 'an-interview-with-bashar', title: "Bashar - An Interview With Bashar" },
  { id: 'preparing-for-contact-101', title: "Bashar - Preparing For Contact 101" },
  { id: 'increasing-probability-of-contact', title: "Bashar - Increasing The Probability Of Contact" },
  { id: 'total-impact', title: "Bashar - Total Impact" },
  { id: 'blueprint-for-contact', title: "Bashar - Blueprint For Contact" },
  { id: 'the-paradox-connection', title: "Bashar - The Paradox Connection" },
  { id: 'predictions-of-our-future', title: "Bashar - Predictions Of Our Future" },
  { id: 'manifesting-your-dreams', title: "Bashar - Manifesting Your Dreams In The 21st Century" },
  { id: 'the-paradox-of-unity', title: "Bashar - The Paradox Of Unity" },
  { id: 'the-13th-floor', title: "Bashar - The 13th Floor" },
  { id: 'parallel-realities', title: "Bashar - Parallel Realities" },
  { id: 'the-nature-of-physical-reality', title: "Bashar - The Nature Of Physical Reality" },
  { id: 'children-of-the-future', title: "Bashar - Children Of The Future" },
  { id: 'allowance', title: "Bashar - Allowance" },
  { id: 'slip-stream-crystal-portals', title: "Bashar - Slip Stream & Crystal Portals" },
  { id: 'a-third-reality', title: "Bashar - A Third Reality" },
  { id: 'et-dolphin-conference', title: "Bashar - The ET Dolphin Conference" },
  { id: 're-creating-yourself', title: "Bashar - Re-Creating Yourself" },
  { id: 'transformation-and-change', title: "Bashar - Transformation And Change" },
  { id: 'keys-of-ascension-workshop', title: "Bashar - Keys Of Ascension Workshop" },
  { id: 'the-formula', title: "Bashar - The Formula" },
  { id: 'the-big-picture', title: "Bashar - The Big Picture" },
  { id: 'continuing-education', title: "Bashar - Continuing Education" },
  { id: 'social-experiment-step-1', title: "Bashar - Social Experiment Step 1" },
  { id: 'social-experiment-step-2', title: "Bashar - Social Experiment Step 2" },
  { id: 'social-experiment-step-4', title: "Bashar - Social Experiment Step 4" },
  { id: 'accelerating-contact', title: "Bashar - Accelerating Contact" },
  { id: 'in-two-worlds', title: "Bashar - In Two Worlds" },
  { id: 'shattering-old-patterns', title: "Bashar - Shattering Old Patterns" },
  { id: 'space-time-travel', title: "Bashar - Space Time Travel" },
  { id: 'stretching-your-limits', title: "Bashar - Stretching Your Limits" },
  { id: 'exploring-the-portal-of-probabilities', title: "Bashar - Exploring The Portal Of Probabilities" },
  { id: 'shedding-new-light-on-negative-beliefs', title: "Bashar - Shedding New Light On Negative Beliefs" },
  { id: 'going-gamma', title: "Bashar - Going Gamma" },
  { id: '1-3-5-7-11-a-refresher-course', title: "Bashar - 1-3-5-7-11 - A Refresher Course" },
  { id: '2019-crossing-the-threshold', title: "Bashar - 2019: Crossing The Threshold" },
  { id: 'interdimensional-portals', title: "Bashar - Interdimensional Portals And Where To Find Them" },
  { id: 'the-neighborhood', title: "Bashar - The Neighborhood" },
  { id: 'ghost-story', title: "Bashar - Ghost Story" },
  { id: 'self-empowerment-workshop', title: "Bashar - Self Empowerment Workshop" },
  { id: 'the-golden-gate', title: "Bashar - The Golden Gate" },
  { id: 'bashar-shares-a-recent-experience', title: "Bashar - Bashar Shares A Recent Experience" },
  { id: 'positive-and-negative', title: "Bashar - Knowing The Difference Between Positive And Negative" },
  { id: 'origin-of-the-human-race', title: "Bashar - The Origin Of The Human Race" },
  { id: 'mechanism-for-achieving-money', title: "Bashar - Mechanism For Achieving Money, Wealth, And Abundance" },
];

const PRICE_PER_VIDEO = 5;

// --- Component for individual selectable card ---
const SelectableCard = ({ item, isSelected, onToggle }) => {
  return (
    <div
      className={`relative cursor-pointer rounded-lg overflow-hidden bg-black/40 flex flex-col
        transition-all duration-200 border
        ${isSelected ? 'border-yellow-500 shadow-md shadow-yellow-500/20 scale-[0.98]' : 'border-gray-700 hover:border-gray-500 hover:bg-black/60'}
      `}
      onClick={() => onToggle(item.id)}
    >
      {/* Thumbnail Container */}
      <div className="relative w-full aspect-video bg-gray-900">
        <img
            src={defaultThumb}
            alt={item.title}
            className="w-full h-full object-contain opacity-80 p-4"
        />
        {/* Selection Checkmark Overlay */}
        {isSelected && (
          <div className="absolute top-2 right-2 bg-yellow-500 rounded-full p-1.5 shadow-lg animate-fade-in">
             <FaCheck className="text-black text-sm" />
          </div>
        )}
      </div>

      {/* Title */}
      <div className="p-3 flex-grow flex items-center">
        <p className={`text-xs sm:text-sm text-white line-clamp-3 ${isSelected ? 'font-semibold' : ''}`}>
            {item.title}
        </p>
      </div>
    </div>
  );
};

// --- Checkout Modal Component ---
const CheckoutModal = ({ isOpen, onClose, selectedItems, onSuccess }) => {
  const { user } = useAuth(); // Get user from auth context
  const location = useLocation(); // For logging

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState(''); // For success messages from API
  const [isLoading, setIsLoading] = useState(false); // For loading state

  // Autofill name and email if user is logged in
  useEffect(() => {
    if (user) {
      setName(user.username || ''); // Assuming user.username exists
      setEmail(user.email || '');     // Assuming user.email exists
    } else {
        setName('');
        setEmail('');
    }
    // Clear messages and errors when modal opens or user changes
    setError('');
    setMessage('');
    setIsLoading(false);
  }, [isOpen, user]); // Depend on isOpen and user to reset/autofill

  if (!isOpen) return null;

  const totalCost = selectedItems.length * PRICE_PER_VIDEO;

  const handleSubmit = async (e) => { // Make handleSubmit async
    e.preventDefault();
    setIsLoading(true);
    setMessage('');
    setError('');

    // Basic frontend validation
    if (!name.trim() || !email.trim()) {
        setError('Please fill in both name and email.');
        setIsLoading(false);
        return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setError('Please enter a valid email address.');
        setIsLoading(false);
        return;
    }
    if (selectedItems.length === 0) {
        setError('Please select at least one transmission.'); // Should ideally not happen if button is disabled
        setIsLoading(false);
        return;
    }

    try {
        const selectedItemIds = selectedItems.map(item => item.id);
        const totalAmount = selectedItems.length * PRICE_PER_VIDEO;

        // Log the initiation of the purchase request
        sendCodedLog({
            message: 'User initiated Bashar transmission purchase request.',
            event: 'bashar_selector_checkout_initiate',
            userName: name,
            userEmail: email,
            selectedItemsCount: selectedItems.length,
            selectedItemsIds: selectedItemIds,
            totalCost: totalAmount,
            ...Common.getCommonLogData(location)
        });

        const response = await fetch(UrlConfig.leads_action, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email,
                nick: name, // Assuming 'nick' corresponds to 'name'
                page: 'BasharSelectorPage', // Specific value for this page
                folder: 'bashar-selector-transmission-request', // Specific section
                status: 'BasharPurchaseInterest', // Specific status for purchase interest
                newsletter: selectedItemIds, // Sending selected item IDs as the 'newsletter' array
                totalCost: totalAmount, // Add total cost to payload
                currency: 'USD', // Add currency to payload
            }),
        });

        const data = await response.json();

        if (response.ok) {
            setMessage(data.message || 'Your request has been sent! I will contact you shortly.');

            // Call the onSuccess callback from the parent
            if (onSuccess) {
                 onSuccess(data.message || 'Your request has been received!'); // Pass success message
            }

            // Log successful submission
            sendCodedLog({
                message: 'User successfully submitted Bashar transmission purchase request.',
                event: 'bashar_selector_checkout_success',
                userName: name,
                userEmail: email,
                selectedItemsCount: selectedItems.length,
                selectedItemsIds: selectedItemIds,
                totalCost: totalAmount,
                ...Common.getCommonLogData(location)
            });

        } else {
            // Log submission error
            sendCodedLog({
                message: 'Failed to submit Bashar transmission purchase request.',
                event: 'bashar_selector_checkout_error',
                userName: name,
                userEmail: email,
                selectedItemsCount: selectedItems.length,
                selectedItemsIds: selectedItemIds,
                totalCost: totalAmount,
                errorMessage: data.message || 'Unknown error',
                ...Common.getCommonLogData(location)
            });
            throw new Error(data.message || 'An error occurred while processing your request.');
        }
    } catch (err) {
        setError(err.message);
    } finally {
        setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={isLoading ? null : onClose}></div> {/* Prevent closing while loading */}

      {/* Modal Content */}
      <div className="relative bg-gray-900 border border-gray-700 rounded-xl max-w-lg w-full p-6 shadow-xl animate-scale-up">
        <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-white"
            disabled={isLoading} // Disable close button while loading
        >
            <FaTimes size={20} />
        </button>

        <h2 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: '"Cinzel Decorative", serif' }}>
            Complete Your Request
        </h2>

        <div className="mb-6">
            <h3 className="text-yellow-500 font-semibold mb-2">Order Summary:</h3>
            <div className="max-h-32 overflow-y-auto bg-black/30 p-3 rounded-md mb-3 border border-gray-800 scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-transparent">
                <ul className="text-sm text-gray-300">
                    {selectedItems.map(item => (
                        <li key={item.id} className="mb-1">• {item.title}</li>
                    ))}
                </ul>
            </div>
            <p className="text-white font-bold">
                Total: {selectedItems.length} items × ${PRICE_PER_VIDEO} = <span className="text-yellow-400">${totalCost} USD</span>
            </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
            <div>
                <label htmlFor="name" className="block text-sm text-gray-400 mb-1">Your Name</label>
                <input
                    type="text"
                    id="name"
                    className="w-full bg-black/50 border border-gray-700 rounded-md py-2 px-3 text-white focus:outline-none focus:border-yellow-500"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    disabled={isLoading} // Disable input while loading
                />
            </div>
            <div>
                <label htmlFor="email" className="block text-sm text-gray-400 mb-1">Your Email</label>
                <input
                    type="email"
                    id="email"
                    className="w-full bg-black/50 border border-gray-700 rounded-md py-2 px-3 text-white focus:outline-none focus:border-yellow-500"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading} // Disable input while loading
                />
            </div>

            {error && <p className="text-red-500 text-sm">{error}</p>}
            {/* Success message will be handled by the ConfirmationModal */}


            <div className="bg-yellow-500/10 border border-yellow-500/30 p-3 rounded-md mt-4">
                <p className="text-sm text-yellow-200">
                    <strong>Next Steps:</strong> After submitting this request, I will contact you at the provided email to finalize the payment and enable access to your selected videos.
                </p>
            </div>

            <div className="flex justify-end gap-3 mt-6">
                 <button
                    type="button"
                    onClick={onClose}
                    className="px-4 py-2 rounded-md text-gray-300 hover:text-white transition-colors"
                    disabled={isLoading} // Disable cancel while loading
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className={`bg-gradient-to-r from-yellow-600 to-yellow-500 text-black font-semibold px-5 py-2 rounded-md transition-all shadow-md
                        ${isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:from-yellow-500 hover:to-yellow-400'}
                    `}
                    disabled={isLoading} // Disable submit while loading
                >
                    {isLoading ? (
                        <svg className="animate-spin h-5 w-5 text-black inline-block mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    ) : null}
                    {isLoading ? 'Sending...' : 'Submit Request'}
                </button>
            </div>
        </form>
      </div>
    </div>
  );
};

// --- NEW ConfirmationModal Component ---
const ConfirmationModal = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 animate-fade-in">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative bg-gray-900 border border-gray-700 rounded-xl max-w-sm w-full p-6 shadow-xl animate-scale-up text-center">
        <h3 className="text-2xl font-bold text-yellow-400 mb-4" style={{ fontFamily: '"Cinzel Decorative", serif' }}>
          Success!
        </h3>
        <p className="text-white text-lg mb-6">
          {/* {message} */}
          I will contact you shortly to finalize the payment and provide access to your selected videos.
        </p>
        <button
          onClick={onClose}
          className="bg-gradient-to-r from-yellow-600 to-yellow-500 text-black font-semibold px-5 py-2 rounded-md hover:from-yellow-500 hover:to-yellow-400 transition-all shadow-md"
        >
          OK
        </button>
      </div>
    </div>
  );
};


// --- Main BasharSelector Component ---
const BasharSelector = () => {
  const location = useLocation();
  const navigate = useNavigate(); // Initialize useNavigate
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [isCheckoutModalOpen, setIsCheckoutModalOpen] = useState(false); // Renamed for clarity
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('');

  const toggleSelection = (id) => {
    setSelectedIds(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  const getSelectedItems = () => {
     return transmissionsData.filter(item => selectedIds.has(item.id));
  };

  // Handler for successful submission from CheckoutModal
  const handleSuccessfulCheckoutSubmission = (message) => {
      setIsCheckoutModalOpen(false); // Close the checkout modal
      setSelectedIds(new Set()); // Clear all selected items
      setConfirmationMessage(message); // Set the message for the confirmation modal
      setIsConfirmationModalOpen(true); // Open the confirmation modal
  };

  // Handler for when the user clicks OK on the confirmation modal
  const handleConfirmationModalClose = () => {
      setIsConfirmationModalOpen(false); // Close the confirmation modal
      navigate('/user/gift'); // Redirect to /user/gift
  };


  const selectedCount = selectedIds.size;
  const totalCost = selectedCount * PRICE_PER_VIDEO;

  return (
    <div className="bg-black text-white min-h-screen font-sans flex flex-col pb-20">
      <div className="absolute inset-0 bg-gradient-to-b from-gray-950 via-black to-gray-900 opacity-95 fixed"></div>

      <main className="relative z-10 flex-grow container mx-auto px-4 py-12 flex flex-col items-center">
        <h1 className="text-3xl sm:text-5xl font-bold text-center mb-4" style={{ fontFamily: '"Cinzel Decorative", serif' }}>
            Select Your Transmissions
        </h1>
        <p className="text-base sm:text-lg text-gray-400 text-center max-w-2xl mb-2">
            Browse the library and select the Bashar transmissions you wish to access.
        </p>
         <p className="text-lg font-semibold text-yellow-500 text-center mb-10">
            Each transmission is ${PRICE_PER_VIDEO} USD.
        </p>

        {/* Grid of Transmissions */}
        <div className="w-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {transmissionsData.map((item) => (
            <SelectableCard
              key={item.id}
              item={item}
              isSelected={selectedIds.has(item.id)}
              onToggle={toggleSelection}
            />
          ))}
        </div>
      </main>

        {/* Sticky Bottom Bar */}
        <div className={`fixed bottom-0 left-0 right-0 bg-gray-900 border-t border-gray-700 p-4 z-40 transition-transform duration-300 ${selectedCount > 0 ? 'translate-y-0' : 'translate-y-full'}`}>
            <div className="container mx-auto max-w-4xl flex items-center justify-between">
                <div>
                     <p className="text-gray-400 text-sm">Selected Items:</p>
                     <p className="text-white font-bold text-lg">
                        {selectedCount} <span className="text-gray-500 mx-1">|</span> Total: <span className="text-yellow-500">${totalCost} USD</span>
                     </p>
                </div>
                <button
                    onClick={() => setIsCheckoutModalOpen(true)} // Open checkout modal
                    disabled={selectedCount === 0}
                    className={`
                        flex items-center gap-2 px-6 py-3 rounded-full font-semibold transition-all
                        ${selectedCount > 0
                            ? 'bg-gradient-to-r from-yellow-600 to-yellow-500 text-black hover:from-yellow-500 hover:to-yellow-400 shadow-lg hover:shadow-yellow-500/20'
                            : 'bg-gray-700 text-gray-400 cursor-not-allowed'}
                    `}
                >
                    <FaShoppingCart />
                    Proceed to Checkout
                </button>
            </div>
        </div>

        {/* Checkout Modal */}
        <CheckoutModal
            isOpen={isCheckoutModalOpen}
            onClose={() => setIsCheckoutModalOpen(false)}
            selectedItems={getSelectedItems()}
            onSuccess={handleSuccessfulCheckoutSubmission} // Pass success handler
        />

        {/* NEW Confirmation Modal */}
        <ConfirmationModal
            isOpen={isConfirmationModalOpen}
            onClose={handleConfirmationModalClose} // Close handler for redirection
            message={confirmationMessage}
        />

      <footer className="relative z-10 text-center py-6 text-xs text-gray-600 mb-16">
        © {new Date().getFullYear()} Gus • Aguiar | On a mission to uplift and transform.
      </footer>
    </div>
  );
};

export default BasharSelector;